export default {
    methods: {
        buildSearchObject(search) {
            let obj = {};

            if (search.query && search.query.length) {
                obj.q = search.query;
            }

            for (let i in search.filters) {
                if (search.filters[i]) {
                    obj[i] = search.filters[i];
                }
            }

            if (search.catalogNumber && search.catalogNumber.length > 0) {
                obj['catalogNumber'] = search.catalogNumber;
            }

            return obj;
        },
        removeFilter(filterKey) {
            for (let key in this.filters) {
                if (key === filterKey) {
                    if (typeof this.filters[key] === 'boolean') {
                        this.filters[key] = false;
                    } else if (typeof this.filters[key] === 'string') {
                        this.filters[key] = null;
                    }
                }
            }
        },
    },

}